import { addressFragment } from '../fragments/address'

const mutation = `mutation customerAddressDelete($addressId: ID!) {
  customerAddressDelete(addressId: $addressId) {
    deletedAddressId
    userErrors {
      field
      message
    }
  }
}`

export default mutation
